import '../Admin/admin-shared.css'
import './admin-coefficient.css'

import { useEffect, useState } from 'react'

import { PageHeader, Spinner } from '../../Components'
import { FC, invalidateQuery, useCQuery } from '../../Services'
import { cap } from '../../State'
import { translations } from '../../translations'
import ServiceSections from './Components/ServiceSections'
import { alert } from './Functions'
const language = cap.language.state || 'IT'
const t = translations[language]

export const AdminCoefficient = () => {
  const { data: adminCoefficient = [], isSuccess } = useCQuery(['adminCoefficient'])
  const [planeCoefficient, setPlaneCoefficient] = useState([])
  const [trainCoefficient, setTrainCoefficient] = useState([])
  const [hotelCoefficient, setHotelCoefficient] = useState([])
  const [carCoefficient, setCarCoefficient] = useState([])

  useEffect(() => {
    const { planeCoefficient, trainCoefficient, hotelCoefficient, carCoefficient } =
      adminCoefficient
    setPlaneCoefficient(planeCoefficient)
    setTrainCoefficient(trainCoefficient)
    setHotelCoefficient(hotelCoefficient)
    setCarCoefficient(carCoefficient)
  }, [adminCoefficient])

  if (!isSuccess) return <Spinner />

  const save = async () => {
    try {
      await FC.service('adminCoefficient').patch(1, {
        planeCoefficient,
        trainCoefficient,
        hotelCoefficient,
        carCoefficient
      })
      alert('success', t.salvataggioEffettuato, '')
      invalidateQuery(['adminCoefficient'])
    } catch (error) {
      alert('error', t.errore, error?.message || 'Errore durante il salvataggio')
    }
  }

  return (
    <div className="admin-coefficient-page admin-page--wide">
      <PageHeader title={t.mxImpostazioneCoefficienti} subtitle={t.mxGestisciNoraAI} />

      <div className="ncard">
        <div className="ncard__body">
          <ServiceSections
            plane={{ coefficient: [planeCoefficient, setPlaneCoefficient] }}
            train={{ coefficient: [trainCoefficient, setTrainCoefficient] }}
            hotel={{ coefficient: [hotelCoefficient, setHotelCoefficient] }}
            car={{ coefficient: [carCoefficient, setCarCoefficient] }}
          />
          <div className="admin-coefficient-save-row">
            <button type="button" className="nbtn nbtn--primary" onClick={save}>
              <i className="pi pi-check" style={{ fontSize: 14 }} />
              {t.salva}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
